import { LoadingOutlined } from "@ant-design/icons";
import { ICompany } from "@/types";
import { setSelectedCompanyInStorage } from "@/services/global-storage";
import { useFetchCompaniesQuery } from "@services";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { paths } from "@/router";
import CompanySelectCarousel from "@components/caurosel";
import CompanyList from "@/components/List/company-list";
import { BiChevronRight } from "react-icons/bi";

const CompanyUser = () => {
  const history = useHistory();
  const [page] = useState(1);
  const [searchString, setSearchString] = useState<string>("");
  const [isCompanySelected, setIsCompanySelected] = useState<boolean>(false);
  // const [selectedCompany, setselectedCompany] = useState<ICompany>();
  const [selectedCompany, setselectedCompany] = useState<string | null>(null);
  const { data: companiesData, isLoading: isFetching } =
    useFetchCompaniesQuery(page);
  const { data } = companiesData || {};

  const onPressNext = (companyId: any) => {
    setIsCompanySelected(true);
    history.push(
      `${paths.client.users.company_users.company_user}/list/${companyId}`
    );
  };
  let handleCompanySelect = (app: any) => {
    setselectedCompany(app);
    setSelectedCompanyInStorage(app);
    onPressNext(app);
  };

  if (!isCompanySelected) {
    return (
      <div className="ApplicationSelector  w-full px-12">
        {isFetching ? (
          // <div className="flex justify-center items-center mt-28">
          //   <LoadingOutlined className="spinner" />
          // </div>
          <div
            style={{ height: "650px" }}
            className="flex justify-center items-center "
          >
            <LoadingOutlined
              className="spinner "
              style={{ fontSize: "80px" }}
            />
          </div>
        ) : (
          <main className="min-h-screen bg-background flex items-center justify-center p-4">
            <div className="w-full ">
              <div className="mb-12">
                <h1 className="text-4xl font-semibold text-foreground text-themeBlue mb-3">
                  Select Company
                </h1>
                <p className="text-base text-muted-foreground font-light">
                  Choose a company to access and manage its operations
                </p>
              </div>

              <CompanyList
                companiesList={data && data}
                onSelectCompany={setselectedCompany}
                selectedCompany={selectedCompany}
              />

              {selectedCompany && (
                <div className="mt-8 flex gap-2  bottom-2 sticky">
                  <button
                    onClick={() => handleCompanySelect(selectedCompany)}
                    className="flex-1 bg-themeBlue text-white px-5 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
                  >
                    {
                      data?.find((item: any) => item?.id == selectedCompany)
                        ?.name
                    }
                    <BiChevronRight className="w-4 h-4" />
                  </button>
                </div>
              )}
            </div>
          </main>
        )}
      </div>
    );
  }
};

export default CompanyUser;
